import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
  EditButton,
  TopToolbar,
  useNotify,
} from 'react-admin';
import { Box, Typography, Paper, Alert } from '@mui/material';
import { useEffect, useState } from 'react';

const ShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

const NotificationShow = (props: any) => {
  const [error, setError] = useState<string | null>(null);
  const notify = useNotify();

  useEffect(() => {
    const handleError = (e: any) => {
      setError(
        'Notifications API is not available yet. This feature will be enabled once the backend is ready.'
      );
    };
    window.addEventListener('unhandledrejection', handleError);
    return () => window.removeEventListener('unhandledrejection', handleError);
  }, []);

  if (error) {
    return <Alert severity="info">{error}</Alert>;
  }

  return (
    <Show actions={<ShowActions />} {...props}>
      <SimpleShowLayout>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            FCM Token Details
          </Typography>
          <TextField source="id" label="Token ID" />
          <TextField source="token" label="FCM Token" />
          <TextField source="userId" label="User ID" />
          <TextField source="device" label="Device Type" />
          <BooleanField source="isActive" label="Active Status" />
          <DateField source="createdAt" label="Created At" showTime />
          <DateField source="updatedAt" label="Updated At" showTime />
        </Paper>
      </SimpleShowLayout>
    </Show>
  );
};

export default NotificationShow; 